import endpoints from 'api/endpoints';
import { normalize } from 'normalizr';
import { topic } from 'schemas';
import Immutable from 'immutable';

export default ({ requestBody }) => ({
  url: endpoints.getSingleTopicUrl(requestBody.id),
  queryKey: `put${endpoints.getSingleTopicUrl()}`,
  transform: response => normalize(response.data, topic.schema).entities,
  body: requestBody,
  meta: {
    authToken: true,
  },
  force: true,
  options: {
    headers: {
      Accept: 'application/json',
    },
    method: 'PUT',
  },
  update: {
    topic: (prevEntities = Immutable.Map(), nextEntities) => prevEntities.mergeDeep(nextEntities),
  },
});
